<template>
    <div id="panel-4" class="panel">
        <div class="panel-hdr bg-danger-800 bg-success-gradient">
            <h2>
                {{ __t('LIST') }}
                <span class="fw-300">
                    <i>{{ __t('ACTION_GROUPS') }}</i>
                </span>
            </h2>
        </div>

        <div class="panel-container show pt-1 pb-1">
            <div class="panel-content">
                <b-overlay
                    :show="is_load"
                    rounded="sm"
                >
                    <div class="rounded">
                        <ul
                            v-if="groups.length > 0"
                            class="nav-menu mb-sm-4 mb-md-0 rounded"
                        >
                            <li
                                v-for="group in groups"
                                :key="group.id"
                            >
                                <a
                                    href="#"
                                    class="waves-effect waves-themed group-item"
                                    :class="{
                                        active_filter: isActive(group)
                                    }"
                                    @click.prevent="toggleGroup(group)"
                                >
                                    <span class="nav-link-text color-black">
                                        <div class="d-flex align-items-center justify-content-between w-100">
                                            <div class="position-relative">
                                                {{ __t(group.title.toUpperCase()) }}

                                                <span class="small text-info ml-1">
                                                    <i
                                                        v-if="group.skeep_sync"
                                                        class="fal fa-lock"
                                                    ></i>
                                                </span>
                                            </div>

                                            <i
                                                v-if="isActive(group)"
                                                class="fal fa-check-circle selected-icon"
                                            ></i>
                                        </div>
                                    </span>

                                    <button
                                        type="button"
                                        class="btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed"
                                        @click.prevent.stop="addAction(group.id)"
                                    >
                                        <i class="fal fa-plus"></i>
                                    </button>
                                </a>
                            </li>
                        </ul>

                        <div
                            v-else-if="!is_load"
                            class="text-center text-muted py-3"
                        >
                            {{ __t('NO_ITEMS') }}
                        </div>
                    </div>
                </b-overlay>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pwa_action_groups",

    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            groups: [],
            is_load: true,
        };
    },

    created() {
        EventBus.$on("reload_groups", this.loadGroups);
        this.loadGroups();
    },

    beforeDestroy() {
        EventBus.$off("reload_groups", this.loadGroups);
    },

    methods: {
        addAction(groupId) {
            EventBus.$emit(
                "action_edit",
                0,
                parseInt(groupId)
            );
        },

        isActive(group) {
            const groupId = parseInt(group.id);

            return this.value.some(
                id => parseInt(id) === groupId
            );
        },

        toggleGroup(group) {
            const groupId = parseInt(group.id);

            let selectedGroups = this.value.map(
                id => parseInt(id)
            );

            if (selectedGroups.includes(groupId)) {
                selectedGroups = selectedGroups.filter(
                    id => id !== groupId
                );
            } else {
                selectedGroups.push(groupId);
            }

            this.$emit("input", selectedGroups);
            this.$emit("change", selectedGroups);
        },

        async loadGroups() {
            this.groups = [];
            this.is_load = true;

            try {
                const { data } = await api.get(
                    "/internal/v1/catalog/pwa/actions/groups"
                );

                if (data.status === "operation_success") {
                    this.groups = Array.isArray(data.data)
                        ? data.data
                        : [];
                } else {
                    this.groups = [];
                }
            } catch (error) {
                this.groups = [];

                const response = error.response;

                EventBus.$emit("show_toast", {
                    err: response?.data?.message || error.message,
                    type: "danger",
                    title: response?.data?.status || "error",
                });
            } finally {
                this.is_load = false;
            }
        },
    },
};
</script>

<style scoped>
.group-item {
    transition: all 0.15s ease-in-out;
    border-left: 4px solid transparent;
}

.group-item:hover {
    background: rgba(136, 95, 183, 0.08);
}

.active_filter {
    background: rgba(136, 95, 183, 0.14) !important;
    border-left-color: #8860b8;
}

.active_filter .nav-link-text {
    color: #6f42a5 !important;
    font-weight: 600;
}

.selected-icon {
    color: #1dc9b7;
    font-size: 16px;
    margin-right: 8px;
}
</style>
